import { svcNoticeService } from "../../../_services/notice-service.js";
import {SET_COMUNICADOS, SET_COMUNICADO, SET_COMUNICADO_ADJUNTOS, SET_COMUNICADOS_STATUS} from "./constants";
import {globalCatch} from "../../../_services/global-catch";
import comunicadosDemo from "../hardcode/comunicados_demo.json";
import comunicadoDemo1 from "../hardcode/comunicado_demo_1.json";
import comunicadoDemo2 from "../hardcode/comunicado_demo_2.json";

export const setComunicados = payload => ({type: SET_COMUNICADOS, payload});
export const setComunicado = payload => ({type: SET_COMUNICADO, payload});
export const setComunicadoAdjuntos = payload => ({type: SET_COMUNICADO_ADJUNTOS, payload});
export const setComunicadosStatus = payload => ({type: SET_COMUNICADOS_STATUS, payload});

export const fetchComunicados = (isTrial) =>
    globalCatch.catch(async (dispatch) => {
        let comunicados

        if (isTrial) {
            comunicados = comunicadosDemo;
            dispatch(setComunicados(comunicados));
            return
        }

        comunicados = await (await svcNoticeService()).getComunicados();
        dispatch(setComunicados(comunicados));
    })

export const fetchComunicado = (uid, isTrial) =>
    globalCatch.catch(async (dispatch) => {
        let comunicado

        if (isTrial) {
            switch (uid) {
                case 'comunicado-demo-1':
                    comunicado = comunicadoDemo1;
                    break;
                case 'comunicado-demo-2':
                    comunicado = comunicadoDemo2;
                    break;
                default:
                    comunicado = null;
            }
            dispatch(setComunicado(comunicado));
            return;
        }

        comunicado = await (await svcNoticeService()).getComunicado(uid);
        dispatch(setComunicado(comunicado));
        dispatch(fetchComunicadosStatus());
    })

export const clearComunciado  = () => ({type: SET_COMUNICADO, payload: null});

export const fetchComunicadoAdjuntosMeta = uid =>
    globalCatch.catch(async (dispatch) => {
        const adjuntos = await (await svcNoticeService()).getComunicadoAdjuntosMeta(uid);
        dispatch(setComunicadoAdjuntos(adjuntos));
    })

export const fetchComunicadosStatus = (isTrial) =>
    globalCatch.catch(async (dispatch) => {
        let status

        if (isTrial) {
            status = { total: 2, unread: 2 }
            dispatch(setComunicadosStatus(status));
            return
        }

        status = await (await svcNoticeService()).getStatus();

        dispatch(setComunicadosStatus(status));
    })


